import {NFLookupCatalog} from "./NFLookupCatalog";
import {AppEntities} from "../../../config/entities";
import {NFLookupCatalogColumn} from "./NFLookupCatalogColumn";
import React, {useState} from "react";
import {ProductTypeEnum} from "../../../enums/Products/ProductTypeEnum";
import {ProductService} from "../../../services/catalogs/ProductService";

interface IProps {
    title?: string;
    fieldName: string;
    required?: boolean;
    showBorder?: boolean;
    width?: number;
    index?: number;
    onValueChanged?: (e: any, index: number) => void;
    value?: any;
    tableName?: string;
    tableFieldName?: string;
    selectedCatalog?: boolean;
    setSelectedCatalog?: (value: boolean) => void;
    modelField?: string;
    withGroups?: boolean;
    productType?: ProductTypeEnum;
}

export const NFLookupProduct = ({
                                    title,
                                    fieldName,
                                    required,
                                    showBorder,
                                    width,
                                    value,
                                    onValueChanged,
                                    index,
                                    tableFieldName,
                                    tableName,
                                    selectedCatalog,
                                    setSelectedCatalog,
                                    modelField,
                                    productType,
                                    withGroups = false
                                }: IProps) => {
    const loadData = async (searchText: string | undefined): Promise<any> => {
        const dataService = (AppEntities.Product.getDataService() as ProductService);
        return await dataService.GetAllNotGroups(searchText, productType);
    };

    return (
        <>
            <NFLookupCatalog
                fieldName={fieldName}
                title={title}
                entity={AppEntities.Product}
                width={width}
                serverData={loadData}
                required={required}
                showBorder={showBorder}
                value={value}
                onValueChanged={onValueChanged}
                index={index}
                tableFieldName={tableFieldName}
                tableName={tableName}
                selectedCatalog={selectedCatalog}
                setSelectedCatalog={setSelectedCatalog}
                modelField={modelField}
            >
                {/*<NFLookupCatalogColumn fieldName={"id"} caption={"Id"}/>*/}
                <NFLookupCatalogColumn fieldName={"name"} caption={"Name"}/>
                <NFLookupCatalogColumn fieldName={"vendorCode"} caption={"Vendor Code"}/>
                <NFLookupCatalogColumn fieldName={"productTypeName"} caption={"Type"}/>
                <NFLookupCatalogColumn fieldName={"mainUnitName"} caption={"Unit"}/>
            </NFLookupCatalog>
        </>
    );
};
